import { FormControlLabel, Switch, Typography } from '@material-ui/core'
import React, { useRef, useState } from 'react'
import { components, constants } from 'cng-web-lib'
import Table from 'src/components/aciacehighway/Table'
import { getStatusMetadata } from 'src/common/NACommon'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import moment from 'moment-timezone'
import XbsngSubmStatusSearchTranslationText from './contexts/XbsngSubmStatusSearchTranslationText'
import XbsngSubmStatusSearchApiUrls from '../../apiUrls/XbsngSubmStatusSearchApiUrls'

const {
  table: {
    DateRangeFilter: CngDateRangeFilter
  }
} = components

const {
  filter: { EQUAL, LIKE, IN, BETWEEN }
} = constants

const PERIOD_SESSION_KEY = 'xbsngSubmStatusLast6Months'

function SubmStatusSearchTablePage(props) {
  const { history, location, showNotification, messageType } = props
  const tableRef = useRef(null)
  const [isLast6Months, setIsLast6Months] = useState(
    sessionStorage.getItem(PERIOD_SESSION_KEY) === 'true'
  )

  function handlePeriodChange(event) {
    const checked = event.target.checked
    sessionStorage.setItem(PERIOD_SESSION_KEY, String(checked))
    setIsLast6Months(checked)
  }

  const xbsngSubmStatusSearchTranslationText = XbsngSubmStatusSearchTranslationText()

  let columns = [
    {
      field: "mblNo",
      sortKey: "mblNo",
      title: xbsngSubmStatusSearchTranslationText.mblNo,
    },
    {
      field: "hblNo",
      sortKey: "hblNo",
      title: xbsngSubmStatusSearchTranslationText.hblNo,
    },
    {
      field: "filerCode",
      sortKey: "filerCode",
      title: xbsngSubmStatusSearchTranslationText.filerCode,
    },
    {
      field: "refNo",
      sortKey: "refNo",
      title: xbsngSubmStatusSearchTranslationText.refNo,
    },
    {
      field: "msgFunc",
      sortKey: "msgFunc",
      title: xbsngSubmStatusSearchTranslationText.msgFunc,
    },
    {
      field: "status",
      sortKey: "status",
      title: xbsngSubmStatusSearchTranslationText.status,
    },
    {
      field: "createdDate",
      sortKey: "createdDate",
      title: xbsngSubmStatusSearchTranslationText.createdDate,
      type: "date",
      filterComponent: CngDateRangeFilter,
      render: (data) => data.createdDate && moment(data.createdDate).tz("Asia/Singapore").format('YYYY-MM-DD HH:mm:ss Z')
    },
    {
      field: "transId",
      sortKey: "transId",
      title: xbsngSubmStatusSearchTranslationText.transId,
    },
    {
      field: "resHblNo",
      sortKey: "resHblNo",
      title: xbsngSubmStatusSearchTranslationText.resHblNo,
    },
    {
      field: "resRefNo",
      sortKey: "resRefNo",
      title: xbsngSubmStatusSearchTranslationText.resRefNo,
    },
    {
      field: "resDate",
      sortKey: "resDate",
      title: xbsngSubmStatusSearchTranslationText.resDate,
      type: "date",
      filterComponent: CngDateRangeFilter,
      render: (data) => data.resDate && moment(data.resDate).tz("Asia/Singapore").format('YYYY-MM-DD HH:mm:ss Z')
    },
    {
      field: "resCode",
      sortKey: "resCode",
      title: xbsngSubmStatusSearchTranslationText.resCode,
    },
    {
      field: "msgType",
      sortKey: "msgType",
      title: xbsngSubmStatusSearchTranslationText.msgType,
    },
    {
      field: "userId",
      sortKey: "userId",
      title: xbsngSubmStatusSearchTranslationText.userId,
    },
    {
      field: "xbsOrgName",
      sortKey: "xbsOrgName",
      title: xbsngSubmStatusSearchTranslationText.xbsOrgId,
    }
  ]

  const filters = [
    {
      label: xbsngSubmStatusSearchTranslationText.mblNo,
      type: 'textfield',
      name: 'mblNo',
      operatorType: LIKE
    },
    {
      label: xbsngSubmStatusSearchTranslationText.hblNo,
      type: 'textfield',
      name: 'hblNo',
      operatorType: LIKE
    },
    {
      label: xbsngSubmStatusSearchTranslationText.status,
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.accepted,
          value: 'Accepted',
          filterValue: { value: 'Accepted' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.rejected,
          value: 'Rejected',
          filterValue: { value: 'Rejected' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.sn,
          value: 'SN',
          filterValue: { value: 'SN' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.cancelled,
          value: 'Cancelled',
          filterValue: { value: 'Cancelled' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.sent,
          value: 'Sent',
          filterValue: { value: 'Sent' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.sendFailed,
          value: 'Send Failed',
          filterValue: { value: 'Send Failed' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.processing,
          value: 'Processing',
          filterValue: { value: 'Processing' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.validationError,
          value: 'Validation Error',
          filterValue: { value: 'Validation Error' }
        },
        {
          fullWidth: true,
          label: xbsngSubmStatusSearchTranslationText.error,
          value: 'Error',
          filterValue: { value: 'Error' }
        }
      ]
    },
    {
      label: xbsngSubmStatusSearchTranslationText.transId,
      type: 'textfield',
      name: 'transId',
      operatorType: LIKE
    }
  ]

  return (
    <>
      <Table
        key={isLast6Months ? '6m' : '90d'}
        toolbarExtra={
          <FormControlLabel
            control={
              <Switch
                checked={isLast6Months}
                color='primary'
                size='small'
                onChange={handlePeriodChange}
              />
            }
            label={xbsngSubmStatusSearchTranslationText.last6Months}
          />
        }
        actions={[
        ]}
        columns={columns}
        compact
        fetch={{ url: XbsngSubmStatusSearchApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() },
          { field: 'msgType', operator: EQUAL, value: messageType },
          {
            field: 'createdDate', type: "datetime", operator: BETWEEN,
            value: {
              startDate: moment().subtract(...(isLast6Months ? [6, 'months'] : [90, 'days'])).format('YYYY-MM-DDT00:00:00.000Z'),
              endDate: moment().format('YYYY-MM-DDT23:59:59.000Z')
            }
          }
        ]}
        filters={filters}
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultField: 'createdDate',
          defaultDirection: 'DESC'
        }}
        persistSettings
        tableRef={tableRef}
      />
    </>
  )
}

export default SubmStatusSearchTablePage